/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindLotsResponseDto } from '../../models/find-lots-response-dto';

export interface FindLots$Params {
  auc_id?: number;
  cat_id?: number;
  part_id?: number;
  lot_state?: string;
  win_bidder_id?: number;
  '$sortby': string;
  '$sortdir': string;
  '$goto_num'?: string;
  '$page'?: number;
  '$maxpagesize': number;
  '$goto'?: number;
  'X-API-Version'?: string;
}

export function findLots(http: HttpClient, rootUrl: string, params: FindLots$Params, context?: HttpContext): Observable<StrictHttpResponse<FindLotsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findLots.PATH, 'get');
  if (params) {
    rb.query('auc_id', params.auc_id, {});
    rb.query('cat_id', params.cat_id, {});
    rb.query('part_id', params.part_id, {});
    rb.query('lot_state', params.lot_state, {});
    rb.query('win_bidder_id', params.win_bidder_id, {});
    rb.query('$sortby', params['$sortby'], {});
    rb.query('$sortdir', params['$sortdir'], {});
    rb.query('$goto_num', params['$goto_num'], {});
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.query('$goto', params['$goto'], {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindLotsResponseDto>;
    })
  );
}

findLots.PATH = '/api/lots';
